export const ENTITY = "@STAT_BY_DOCUMENT";